/*
 * BBC - Rap Map - Error message display
 *
 * @author Matt Haynes <matt@joipolloi.com>
 * @package BBC Rap Map
 */

import React from 'react';

const Error = () => (
    <div className="Error">
        <h2>The Rap Game UK</h2>
        <p>Something’s gone wrong. Reload my selector!</p>
    </div>
);

export default Error;
